import {
  mintNftFileScheme,
  mintNftDetailsScheme,
  mintNftCoverImageScheme,
  mintNftDescriptionSchema,
} from "@/validationSchemas";

const stepsDefault = [
  {
    component: "MintNftFile",
    title: "NFT File",
    scheme: mintNftFileScheme,
  },
  {
    title: "",
  },
  {
    title: "",
  },
  {
    title: "",
  },
];
const stepsForImages = [
  {
    component: "MintNftFile",
    title: "NFT File",
    scheme: mintNftFileScheme,
  },
  {
    component: "MintDescription",
    title: "Description",
    scheme: mintNftDescriptionSchema,
  },
  {
    component: "MintDetails",
    title: "Details",
    scheme: mintNftDetailsScheme,
  },
];
const stepsForOtherMimeTypes = [
  {
    component: "MintNftFile",
    title: "NFT File",
    scheme: mintNftFileScheme,
  },
  {
    component: "MintCoverImage",
    title: "Cover Image",
    scheme: mintNftCoverImageScheme,
  },
  {
    component: "MintDescription",
    title: "Description",
    scheme: mintNftDescriptionSchema,
  },
  {
    component: "MintDetails",
    title: "Details",
    scheme: mintNftDetailsScheme,
  },
];
const initialState = {
  name: "",
  tags: "",
  errors: [],
  duration: 0,
  currentStep: 1,
  description: "",
  royalties: null,
  isMinting: false,
  isLoading: false,
  selectedFile: {},
  backgroundUrl: "",
  fileTypeCover: "",
  coverImageFile: {},
  mintingMessage: "",
  alternativeText: "",
  isMintingFinished: false,
  requiresCoverImage: false,
  shouldShowNftPreview: true,
  isCoverAutogenerated: false,
  shouldShowMintNftStepper: true,
  currentStepsArray: stepsDefault,
};
const state = initialState;
const getters = {
  getByKey: (state) => (key) => state[key],
  isFileSelected: (state) => Boolean(state.selectedFile.type),
  getSelectedFileMimeType: (state) => state.selectedFile?.type?.split("/")[1],
  getSelectedFileType: (state) => state.selectedFile?.type?.split("/")[0],
  getSelectedFileExtension: (state) =>
    state.selectedFile?.name?.substring(
      state.selectedFile?.name?.lastIndexOf(".") + 1,
      state.selectedFile?.name?.length
    ),
  getCurrentStepsArray: (state) => state.currentStepsArray,
  getIsLoading: (state) => state.isLoading,
};
const mutations = {
  changeCurrentStepsArray(state, fileType) {
    state.currentStepsArray =
      fileType === "image" ? stepsForImages : stepsForOtherMimeTypes;
  },
  setIsLoading(state, val) {
    state.isLoading = val;
  },
  setBackgroundUrl(state, url) {
    state.backgroundUrl = url;
  },
  setByKey(state, obj) {
    state[obj.key] = obj.value;
  },
  incrementStep(state, step) {
    state.currentStep += step;
  },
  decrementStep(state, step) {
    state.currentStep -= step;
  },
  commitByKey(state, object) {
    Object.keys(object).forEach((key) => (state[key] = object[key]));
  },
  resetState(state) {
    return Object.assign(state, initialState);
  },
  pushError(state, error) {
    state.errors.push(error);
  },
  clearErrors(state) {
    state.errors.splice(0);
  },
  removeError(state, removeError) {
    state.errors = state.errors.filter((error) => error !== removeError);
  },
  getDuration(state, duration) {
    state.duration = duration;
  },
};
const actions = {
  setByKey({ commit }, obj) {
    commit("setByKey", obj);
  },
  incrementStep({ commit }, step = 1) {
    commit("incrementStep", step);
  },
  decrementStep({ commit }, step = 1) {
    commit("decrementStep", step);
  },
  changeCurrentStepsArray({ commit }, fileType) {
    commit("changeCurrentStepsArray", fileType);
  },
  setBackgroundUrl({ commit }, file) {
    commit("setBackgroundUrl", file);
  },
  setIsLoading({ commit }, val) {
    commit("setIsLoading", val);
  },
  commitByKey({ commit }, object) {
    commit("commitByKey", object);
  },
  resetState({ commit }) {
    commit("resetState");
  },
  pushError({ commit }, error) {
    commit("pushError", error);
  },
  clearErrors({ commit }) {
    commit("clearErrors");
  },
  removeError({ commit }, error) {
    commit("removeError", error);
  },
  getDuration({ commit }, duration) {
    commit("getDuration", duration);
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true,
};
